export default function errors(state = {}, action) {
  const { type, error } = action;
  const err_msg = error ? error.data : "";
  const matches = /(.*)_(REQUEST|FAILURE|CLEARERR)/.exec(type);

  // not a *_REQUEST / *_FAILURE / *_CLEARERR actions, so we ignore them
  if (!matches) return state;

  const [, requestName, requestState] = matches;
  return {
    ...state,
    // Store errorMessage
    // e.g. stores errorMessage when receiving XXX_FAILURE
    //      else clear errorMessage when receiving XXX_REQUEST OR XXX_CLEARERR
    [requestName]: requestState === "FAILURE" ? err_msg : "",
  };
}
